import { Inject, Injectable, Optional } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Tenant } from '../../core/models/Tenant';

@Injectable({
  providedIn: 'root',
})
export class TenantApiService {
  private basePath: string;

  constructor(
    private http: HttpClient,
    @Inject('env') @Optional() private env?: any,
  ) {
    this.basePath = this.env?.basePath || '';
  }

  /**
   * Retrieves the Tenant configuration for the current authenticated user.
   * @param userId The UUID of the authenticated user.
   */
  getTenantByUser(userId: string): Observable<Tenant> {
    const url = `${this.basePath}/api/tenant/by-user/${userId}`;
    return this.http.get<Tenant>(url);
  }
}
